// src/pages/SingaleProductTemplate.js
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import './SingaleProductTemplate.css';
import axios from 'axios';
import GalleryProdutImageSingaleProductPage from '../../../components/GalleryProdutImageSingaleProductPage/GalleryProdutImageSingaleProductPage';
import BuyNowAndAddToCartProduct from '../../../components/BuyNowAndAddToCartProduct/BuyNowAndAddToCartProduct';
import MoreInfoProducts from '../../../components/MoreInfoProducts/MoreInfoProducts';
import MiniProductsCarouselHome from '../../../components/MiniProductsCarouselHome/MiniProductsCarouselHome';
import visaImg from './visa.gif';

const SingaleProductTemplate = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get('/api/products')
      .then(res => {
        const foundProduct = res.data.find(item => item.id === parseInt(id));
        if (foundProduct) {
          try {
            foundProduct.images = JSON.parse(foundProduct.images || '[]');
          } catch (e) {
            foundProduct.images = [];
          }
          setProduct(foundProduct);
        } else {
          setError("המוצר לא נמצא");
        }
        setLoading(false);
      })
      .catch(err => {
        setError("שגיאה בטעינת מוצרים");
        setLoading(false);
      });
  }, [id]);

  if (loading) return <p>טוען מוצר...</p>;
  if (error) return <p>{error}</p>;

  const imageUrl = product.images?.[0]?.startsWith('http')
    ? product.images[0]
    : `https://buytaxi.co.il${product.images?.[0] || ''}`;

  return (
    <>
<Helmet>
  {/* Title + Description */}
  <title>{product.name} - מוצרי קיץ לרכב ולבית | AutoPro</title>
  <meta
    name="description"
    content={
      product.description?.substring(0, 160) ||
      "המוצרים הכי חמים לקיץ! גאדג'טים לרכב, מאווררים, בריכות, פתרונות קירור, ציוד לחוף ועוד – רק ב-AutoPro."
    }
  />

  {/* Keywords */}
  <meta
    name="keywords"
    content="מוצרי קיץ, גאדג'טים לרכב, אביזרים לרכב, בריכה מתנפחת, מאוורר נייד, ציוד לים, AutoPro, חנות קיץ, קיץ 2025, קניות אונליין"
  />

  {/* Author */}
  <meta name="author" content="AutoPro.co.il" />

  {/* Canonical */}
  <link rel="canonical" href={`https://autopro.co.il/product/${product.id}`} />

  {/* Open Graph */}
  <meta property="og:title" content={product.name} />
  <meta property="og:description" content={product.description?.substring(0, 160)} />
  <meta property="og:image" content={imageUrl} />
  <meta property="og:url" content={`https://autopro.co.il/product/${product.id}`} />
  <meta property="og:type" content="product" />
  <meta property="og:site_name" content="AutoPro" />
  <meta property="og:locale" content="he_IL" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content={product.name} />
  <meta name="twitter:description" content={product.description?.substring(0, 160)} />
  <meta name="twitter:image" content={imageUrl} />
  <meta name="twitter:site" content="@AutoPro" />

  {/* Structured Data */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Product",
      name: product.name,
      image: imageUrl,
      description: product.description?.substring(0, 160),
      brand: {
        "@type": "Brand",
        name: "AutoPro"
      },
      offers: {
        "@type": "Offer",
        priceCurrency: "ILS",
        price: product.price,
        availability: "https://schema.org/InStock",
        url: `https://autopro.co.il/product/${product.id}`
      }
    })}
  </script>
</Helmet>


      <div className="product-page-container">

        <div className="product-breadcrumb">
          <span className="breadcrumb-link" onClick={() => window.location.href = '/Products'}>
            כל המוצרים
          </span> {'>'} {product.name}
        </div>

        <div className="product-grid">
          <div className="image-gallery">
            <GalleryProdutImageSingaleProductPage images={product.images} />
          </div>

          <div className="product-details">
            <h1 className="product-title">{product.name}</h1>
            <p className="product-description">{product.description}</p>
            <p className="product-price">₪ {product.price}</p>

            <div className="product-actions">
              <BuyNowAndAddToCartProduct product={product} />
            </div>

            <div className="payment-icons">
              <img src={visaImg} alt="אמצעי תשלום" className="visa-mastercard-image" />
            </div>
          </div>
        </div>

        <div className="moreinfo-container">
          <div className="moreinfo-box">
            <MoreInfoProducts moreinfo={product.moreinfo} />
          </div>
        </div>

        <div className='MoreProductSingaleProduct'>
          <h2 className='MoreProductH2SingaleProductPage'> מוצרים נוספים</h2>
          <MiniProductsCarouselHome />
        </div>
      </div>
    </>
  );
};

export default SingaleProductTemplate;
